import { useState } from 'react'
import { Network } from 'lucide-react'
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'

interface Props {
  enabled: boolean
  onChange: (enabled: boolean) => Promise<boolean>
}

export default function WorldGraphSwitchCard({ enabled, onChange }: Props) {
  const [saving, setSaving] = useState(false)

  const toggle = async (next: boolean) => {
    setSaving(true)
    await onChange(next)
    setSaving(false)
  }

  return (
    <Card className='bg-white shadow-md'>
      <CardHeader>
        <div className='flex items-start justify-between gap-6'>
          <div className='flex items-start gap-3'>
            <div className='rounded-lg bg-dark-blue/10 p-2'>
              <Network className='h-7 w-7 text-dark-blue' aria-hidden />
            </div>
            <div>
              <CardTitle className='text-2xl font-bold text-dark-blue'>
                World graph
              </CardTitle>
              <CardDescription className='mt-1 max-w-2xl'>
                An optional game type. The scenario is turned into a causal
                model of its world, one step at a time, and you approve each
                step. Turning it on only adds these setup steps: players and the
                rest of this room are unchanged.
              </CardDescription>
            </div>
          </div>
          <div className='flex items-center gap-2 pt-1'>
            <Switch
              id='world-graph-enabled'
              checked={enabled}
              disabled={saving}
              onCheckedChange={toggle}
            />
            <Label htmlFor='world-graph-enabled' className='text-dark-blue'>
              {enabled ? 'On' : 'Off'}
            </Label>
          </div>
        </div>
      </CardHeader>
    </Card>
  )
}
